import Header from "./components/Header";
import Hero from "./components/Hero";
import Channels from "./components/Channels";
import HotFeed from "./components/HotFeed";
import Ranking from "./components/Ranking";
import WhyFree from "./components/WhyFree";
import Praise from "./components/Praise";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Header />
      <Hero />
      <Channels />
      <HotFeed />
      <Ranking />
      <WhyFree />
      <Praise />
      <Faq />
      <Footer />
    </main>
  );
}